import PropsTable from './PropsTable'

export default PropsTable
